// @ts-nocheck
/* eslint-disable */

import * as Types from '../../graphql/v3/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CitySelectQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CitySelectQuery = { __typename?: 'Query', filterCity?: Array<{ __typename?: 'City', id: number, name: string }> | null };


export const CitySelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CitySelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterCity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
export function useCitySelectQuery(baseOptions?: Apollo.QueryHookOptions<CitySelectQuery, CitySelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitySelectQuery, CitySelectQueryVariables>(CitySelectDocument, options);
      }
export function useCitySelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitySelectQuery, CitySelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitySelectQuery, CitySelectQueryVariables>(CitySelectDocument, options);
        }
export function useCitySelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CitySelectQuery, CitySelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CitySelectQuery, CitySelectQueryVariables>(CitySelectDocument, options);
        }
export type CitySelectQueryHookResult = ReturnType<typeof useCitySelectQuery>;
export type CitySelectLazyQueryHookResult = ReturnType<typeof useCitySelectLazyQuery>;
export type CitySelectSuspenseQueryHookResult = ReturnType<typeof useCitySelectSuspenseQuery>;